import { CSS } from "../../constants/css";

const instance = ($el: HTMLElement) => {
  const dom = {
    $html: document.querySelector<HTMLElement>("html"),
    $menu: $el.querySelector<HTMLElement>(".js-menu"),
    $toggleBtn: $el.querySelector<HTMLElement>(".js-menu-toggle"),
  };

  const setupListeners = () => {
    dom.$toggleBtn?.addEventListener("click", function () {
      toggle(this);
    });
  };

  const toggle = (el: HTMLElement) => {
    dom.$menu?.classList.toggle(CSS.active);

    dom.$html?.classList.toggle(CSS.overflowHiddenForNav);
    dom.$toggleBtn?.classList.toggle(CSS.active);

    el.setAttribute(
      "aria-expanded",
      el.getAttribute("aria-expanded") === "true" ? "false" : "true",
    );
  };

  setupListeners();
};

export default () => {
  const $nav = document.querySelectorAll<HTMLElement>(".js-nav");

  $nav.forEach(($element) => {
    instance($element);
  });
};
